window.addEventListener('DOMContentLoaded', () => {
    // Tous les boutons 'add_to_cart' d'ajout rapide en ajax
    const addToCartButtons = document.querySelectorAll('.add_to_cart_button');
    addToCartButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            const dataset = event.target.dataset;
            triggerAddToCartEvent(dataset.product_id, dataset.quantity);
        });
    });
});

/**
 * Déclenche l'évenement GA4 'add_to_cart'
 *
 * @param {int} productID
 * @param {int} productQuantity
 */
function triggerAddToCartEvent(productID, productQuantity) {
    dataLayer.push({
        'event': 'add_to_cart',
        'ecommerce': {
            'add': {
                'products': [{
                    'id': productID,
                    'quantity': productQuantity
                }]
            }
        }
    });
}